/* eslint-disable no-console */
import { PING_PONG_CLICKSTREAM_EVENT_SOURCE } from '../components/Ameyo/constants';
import { LocalStorageObserver } from './LocalStorageObserver.service';
import { CLICKSTREAM_EVENT_NAMES } from './clickStream.constant';
import { addClickstreamEvent } from './clickStreamEventService';

export const naviExtension: any = {};
const IS_AVAILABLE_KEY = 'isAmeyoAvailable';
const AMEYO_CAMPAIGN_ID = 'ameyoCampaignId';
const AMEYO_STATUS = 'ameyoStatus';
const CURRENT_CALL_STATUS = 'currentAmeyoCallStus';
const IS_LH_PENDING = 'isPending';
export enum AMEYO_STATUS_CODES {
  'LOGGED_OUT' = 'loggedOut',
  'LOADING' = 'loading',
  'LOGGED_IN' = 'loggedIn',
  'AUTH_ERROR' = 'authError',
  'DASHBOARD_LOADED' = 'dashboardLoaded',
  'READY' = 'ready'
}

export enum AMEYO_CALL_EVENTS {
  'IDLE' = 'idle',
  'RINGING' = 'ringing',
  'CONNECTED' = 'connected',
  'REJECTED' = 'rejected',
  DISCONNECTED = 'disconnected'
}

let wasAttended = false;

const originalCallbacks = {
  onCallIncoming: (phoneNumber: string, lan: string, crtObjectId: string) => {
    console.log('AMEYO_LH no onCallIncoming callback found', phoneNumber, lan, crtObjectId);
  },
  onCallConnected: (phoneNumber: string, lan: string, crtObjectId: string, callId: string) => {
    console.log(
      'AMEYO_LH no onCallConnected callback found',
      phoneNumber,
      lan,
      crtObjectId,
      callId
    );
  },
  onCallRejected: (phoneNumber: string, lan: string, crtObjectId: string) => {
    console.log('AMEYO_LH no onCallRejected callback found', phoneNumber, lan, crtObjectId);
  },
  onCallDisconnected: (phoneNumber: string, lan: string, crtObjectId: string, callId: string) => {
    console.log(
      'AMEYO_LH no onCallDisconnected callback found',
      phoneNumber,
      lan,
      crtObjectId,
      callId
    );
  },
  onAvailabilityChange: (isAvailable: boolean) => {
    console.log('AMEYO_LH no onAvailabilityChange callback found', isAvailable);
  },
  onError: (error: { type: string; errorMessage: string }) => {
    console.log('AMEYO_LH no onError callback found', error);
  },
  onAmeyoStateChange: (status: AMEYO_STATUS_CODES) => {
    console.log('AMEYO_LH no onAmeyoStateChange callback found', status);
  },
  onAmeyoCallStatusChanged: (callData: AmeyoCallData) => {
    console.log('AMEYO_LH no onAmeyoCallStatusChanged callback found', callData);
  },
  campaignId: (campaignId: string) => {
    console.log('AMEYO_LH no campaignId callback found', campaignId);
  },
  multipleCampaignsNextButtonClicked: () => {
    console.log('AMEYO_LH no multipleCampaignsNextButtonClicked callback found');
  },
  toggleAmeyoStatus: (onToggleAmeyoStatusData: {
    ameyoTogglePrevStatus: 'OFF' | 'ON';
    ameyoToggleNewStatus: 'OFF' | 'ON';
  }) => {
    console.log('AMEYO_LH no toggleAmeyoStatus callback found', onToggleAmeyoStatusData);
  },
  ameyoErroneous: () => {
    console.log('AMEYO_LH no ameyoErroneous callback found');
  },
  ameyoGenericClickstream: (data: any) => {
    console.log('AMEYO_LH no ameyoGenericClickstream callback found', data);
  },
  ameyoBackgroundTabOpened: (data: any) => {
    console.log('AMEYO_LH no ameyoBackgroundTabOpened callback found', data);
  },
  ameyoTabOpeningAttempt: (data: any) => {
    console.log('AMEYO_LH no ameyoTabOpeningAttempt callback found', data);
  },
  ameyoBackgroundTabOpenFailed: (data: any) => {
    console.log('AMEYO_LH no ameyoBackgroundTabOpenFailed callback found', data);
  },
  manualLogin: (data: any) => {
    console.log('AMEYO_LH no manualLogin callback found', data);
  },
  onExtensionToggleMidCallClick: () => {
    console.log('AMEYO_LH no onExtensionToggleMidCallClick callback found');
  },
  ameyoReloaded: () => {
    console.log('AMEYO_LH no ameyoReloaded callback found');
  },
  pingPongClickstream: (data: {
    sender: PING_PONG_CLICKSTREAM_EVENT_SOURCE;
    referenceId: string;
  }) => {
    if (data?.sender === PING_PONG_CLICKSTREAM_EVENT_SOURCE.AMEYO) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_AMEYO_PONG_RECEIVED_AMEYO, {
        clickstreamSenderType: PING_PONG_CLICKSTREAM_EVENT_SOURCE.AMEYO,
        pongReferenceId: data?.referenceId
      });
    } else {
      console.log('AMEYO_LH no pingPongClickstream callback found for sender', data?.sender);
    }
  },
  acceptCallError: () => {
    console.log('AMEYO_LH on accept call callback found ');
  },
  sendCurrentCallStatus: () => {
    console.log('AMEYO_LH on sendCurrentCallStatus call callback found ');
  },
  sendCurrentCallStatusAndRecalibrate: (data?: IAmeyoRecalibratedData) => {
    console.log('AMEYO_LH on sendCurrentCallStatusAndRecalibrate call callback found ');
  },
  acceptCallClickFailure: (messageType: MessagingType) => {
    console.log('AMEYO_LH on acceptCallClickFailure call callback found ');
  },
  rejectCallClickFailure: (messageType: MessagingType) => {
    console.log('AMEYO_LH on rejectCallClickFailure call callback found ');
  },
  disconnectCallClickFailure: (messageType: MessagingType) => {
    console.log('AMEYO_LH on disconnectCallClickFailure call callback found ');
  },
  disposeCallClickFailure: (messageType: MessagingType) => {
    console.log('AMEYO_LH on disposeCallClickFailure call callback found ');
  }
  //when ameyo becomes loggedout, reset the state()
};
let extensionCallbacks = { ...originalCallbacks };
// function resetState() {
//   localStorage.removeItem(AMEYO_STATUS);
//   resetCallAndFormStateData();
// }

function resetAllAmeyoData() {
  resetAvailabilty();
  resetCallAndFormStateData();
}

function resetCallAndFormStateData() {
  localStorage.removeItem(IS_LH_PENDING);
  resetCallStatus();
}
function resetAvailabilty() {
  localStorage.removeItem(IS_AVAILABLE_KEY);
}

export function startNaviExtensionService() {
  naviExtension.registerCallBack = (callbacks: NaviExtensionCallbackRegister) => {
    extensionCallbacks = { ...extensionCallbacks, ...callbacks };
  };
  naviExtension.unregisterAllCallbacks = (callbacks: NaviExtensionCallbackRegister) => {
    extensionCallbacks = { ...originalCallbacks };
  };
  window.removeEventListener('message', msgListner);
  window.addEventListener('message', msgListner, false);
  naviExtension.login = (email: string, password: string) => {
    window.postMessage({
      type: MessagingType.DO_LOGIN,
      data: { email, password }
    });
  };
  naviExtension.logout = (email: string, password: string) => {
    window.postMessage({ type: MessagingType.DO_LOGOUT, data: {} });
    setTimeout(() => {
      window.postMessage({ type: MessagingType.DO_LOGOUT, data: {} });
    }, 2000);
  };
  naviExtension.acceptCall = () => {
    window.postMessage({ type: MessagingType.ACCEPT_INCOMING_CALL, data: {} });
  };
  naviExtension.muteCall = () => {
    window.postMessage({ type: MessagingType.MUTE_ONGOING_CALL, data: {} });
  };
  naviExtension.unMuteCall = () => {
    window.postMessage({ type: MessagingType.UNMUTE_ONGOING_CALL, data: {} });
  };
  naviExtension.rejectCall = () => {
    window.postMessage({ type: MessagingType.REJECT_INCOMING_CALL, data: {} });
    wasAttended = true;
    setTimeout(() => {
      naviExtension.disposeCall();
    }, 4000);
  };
  naviExtension.disconnectCall = () => {
    window.postMessage({ type: MessagingType.DISCONNECT_CALL, data: {} });
  };
  naviExtension.setAvailability = (shouldBeAvailable: boolean) => {
    window.postMessage({ type: MessagingType.SET_AMEYO_AVAILABILTY, data: shouldBeAvailable });
  };
  naviExtension.enableAmeyo = () => {
    window.postMessage({ type: MessagingType.ENABLE_AMEYO, data: {} });
  };
  naviExtension.disableAmeyo = () => {
    window.postMessage({ type: MessagingType.DISABLE_AMEYO, data: {} });
  };
  naviExtension.disposeCall = () => {
    setTimeout(() => {
      window.postMessage({ type: MessagingType.DISPOSE_CALL, data: {} });
    }, 3000);
  };
  naviExtension.focusAmeyotab = () => {
    window.postMessage({ type: MessagingType.FOCUS_AMEYO_TAB, data: {} });
  };
  naviExtension.focusChromeExtensionsPage = () => {
    window.postMessage({ type: MessagingType.FOCUS_CHROME_EXTENSIONS_PAGE, data: {} });
  };
  naviExtension.blockSlash = () => {
    window.postMessage({ type: MessagingType.BLOCK_SLASH, data: {} });
  };
  naviExtension.unblockSlash = () => {
    window.postMessage({ type: MessagingType.UNBLOCK_SLASH, data: {} });
  };

  // use :  to have a state that there is an ongoing process on the client and
  // call event times have to be preserved until, task is no more pending
  // when isPending=true, all the new calls would be auto rejected, and no overwrites will be made
  // for the call statuses
  naviExtension.updateIsPending = (isPending: boolean) => {
    console.log('LH DEBUG updateIsPending called', isPending);
    if (isPending) {
      localStorage.setItem(IS_LH_PENDING, Date.now() + '');
    } else {
      localStorage.removeItem(IS_LH_PENDING);
    }
  };
  naviExtension.getIsPending = (): boolean => {
    console.log('LH DEBUG getIsPending called', !!localStorage.getItem(IS_LH_PENDING));
    return !!localStorage.getItem(IS_LH_PENDING);
  };
  naviExtension.isAvailable = () => !!localStorage.getItem(IS_AVAILABLE_KEY);
  naviExtension.resetAllAmeyoData = resetAllAmeyoData;
  naviExtension.currentCallStatus = () =>
    JSON.parse(localStorage.getItem(CURRENT_CALL_STATUS) || '{}');
  naviExtension.currentAmeyoStatus = () =>
    localStorage.getItem(AMEYO_STATUS) || AMEYO_STATUS_CODES.LOGGED_OUT;
  naviExtension.resetCallStatus = resetCallStatus;
  naviExtension.getCurrentCallStatus = () => {
    window.postMessage({ type: MessagingType.GET_CURRENT_CALL_STATUS });
  };
  naviExtension.disableExtensionToggle = (state: boolean) => {
    window.postMessage({ type: MessagingType.DISABLE_EXTENSION_TOGGLE, data: state });
  };
  window.naviExtension = naviExtension;
  observeCallStatus();
}
function setCurrentCallStatus(data: Partial<AmeyoCallData>) {
  const currentStatus = JSON.parse(localStorage.getItem(CURRENT_CALL_STATUS) || '{}');
  const updatedValue = { ...currentStatus, ...data };
  extensionCallbacks.onAmeyoCallStatusChanged(updatedValue);
  localStorage.setItem(CURRENT_CALL_STATUS, JSON.stringify(updatedValue));
}

function observeCallStatus() {
  console.log('CALLED observeCallStatus');
  const unsubCallStatus = new LocalStorageObserver(CURRENT_CALL_STATUS, updatedValue => {
    console.log('observeCallStatus', updatedValue, JSON.parse(updatedValue + ''));
    extensionCallbacks.onAmeyoCallStatusChanged(JSON.parse(updatedValue + ''));
  });
}

export interface AmeyoCallData {
  ringingAt: number | undefined;
  acceptedAt: number | undefined;
  disconnectedAt: number | undefined;
  mutedAt: number | undefined;
  unMutedAt: number | undefined;
  phoneNumber: string | undefined;
  lan: string | undefined;
  crtObjectId: string | undefined;
}
function resetCallStatus() {
  setCurrentCallStatus({
    ringingAt: undefined,
    acceptedAt: undefined,
    mutedAt: undefined,
    unMutedAt: undefined,
    disconnectedAt: undefined,
    phoneNumber: undefined,
    lan: undefined,
    crtObjectId: undefined
  });
}

function silentlyDisposeCall() {
  setTimeout(() => {
    naviExtension.disposeCall();
  }, 4000);
}

function msgListner(msg: any) {
  const message: MessagingRequest = msg.data;
  if (message.type === MessagingType.ON_AMEYO_CALL_INCOMING) {
    wasAttended = false;
    if (!naviExtension.getIsPending()) {
      setCurrentCallStatus({
        ringingAt: Date.now(),
        disconnectedAt: undefined,
        acceptedAt: undefined,
        mutedAt: undefined,
        unMutedAt: undefined,
        phoneNumber: message.data?.phoneNumber,
        lan: message.data?.lan,
        crtObjectId: message.data?.crtObjectId
      });
    }
    extensionCallbacks.onCallIncoming(
      message.data?.phoneNumber,
      message.data?.lan,
      message.data?.crtObjectId
    );
  }
  if (message.type === MessagingType.ON_AMEYO_CALL_ACCEPTED) {
    wasAttended = true;
    setCurrentCallStatus({
      acceptedAt: Date.now(),
      disconnectedAt: undefined,
      mutedAt: undefined,
      unMutedAt: undefined,
      phoneNumber: message.data?.phoneNumber,
      lan: message.data?.lan,
      crtObjectId: message.data?.crtObjectId
    });
    extensionCallbacks.onCallConnected(
      message.data?.phoneNumber,
      message.data?.lan,
      message.data?.crtObjectId,
      message.data?.callId
    );
  }
  if (message.type === MessagingType.MUTE_ONGOING_CALL) {
    wasAttended = true;
    setCurrentCallStatus({
      mutedAt: Date.now(),
      unMutedAt: undefined
    });
    extensionCallbacks.onCallConnected(
      message.data?.phoneNumber,
      message.data?.lan,
      message.data?.crtObjectId,
      message.data?.callId
    );
  }
  if (message.type === MessagingType.UNMUTE_ONGOING_CALL) {
    wasAttended = true;
    setCurrentCallStatus({
      mutedAt: undefined,
      unMutedAt: Date.now()
    });
    extensionCallbacks.onCallConnected(
      message.data?.phoneNumber,
      message.data?.lan,
      message.data?.crtObjectId,
      message.data?.callId
    );
  }
  if (message.type === MessagingType.ON_AMEYO_CALL_DISCONNECTED) {
    const currentStatus = naviExtension.currentCallStatus();
    if (!wasAttended) {
      extensionCallbacks.onError({
        type: ErrorTypes.GENERIC,
        errorMessage: `Customer's call got disconnected`
      });
    }
    // the reject was clicked or the customer hundup before we could act, in the ringing phase.
    if (!currentStatus.acceptedAt) {
      // if(isNotPending())
      resetCallStatus();
      silentlyDisposeCall();
    } else if (currentStatus.disconnectedAt) {
      silentlyDisposeCall();
    } else if (!currentStatus?.disconnectedAt) {
      // means the call was accepted and conversation was there.
      setCurrentCallStatus({
        disconnectedAt: Date.now(),
        mutedAt: undefined,
        unMutedAt: undefined,
        phoneNumber: message.data?.phoneNumber,
        lan: message.data?.lan,
        crtObjectId: message.data?.crtObjectId
      });
    }
    extensionCallbacks.onCallDisconnected(
      message.data?.phoneNumber,
      message.data?.lan,
      message.data?.crtObjectId,
      message.data?.callId
    );
  }
  if (message.type === MessagingType.ON_ERROR) {
    if (message.data.type === ErrorTypes.AUTH_ERROR) {
      localStorage.setItem(AMEYO_STATUS, AMEYO_STATUS_CODES.AUTH_ERROR);
      extensionCallbacks.onAmeyoStateChange(AMEYO_STATUS_CODES.AUTH_ERROR);
    }
    extensionCallbacks.onError(message.data);
  }
  if (message.type === MessagingType.ON_AMEYO_STATUS_CHANGE) {
    console.log('__AMEYO status changes', message.data);
    localStorage.setItem(AMEYO_STATUS, message.data);
    if (message.data === AMEYO_STATUS_CODES.LOGGED_IN) {
      console.log('NCE AMEYO_STATUS reseting AuthData');
      resetAvailabilty();
      if (!naviExtension.getIsPending()) {
        resetCallAndFormStateData();
      }
    }
    if (message.data === AMEYO_STATUS_CODES.LOGGED_OUT) {
      console.log('NCE AMEYO_STATUS reseting all data');
      resetCallAndFormStateData();
    }
    extensionCallbacks.onAmeyoStateChange(message.data);
  }
  if (message.type === MessagingType.ON_AMEYO_AVAILABILTY_CHANGE) {
    if (message.data) {
      localStorage.setItem(IS_AVAILABLE_KEY, 'true');
    } else {
      localStorage.removeItem(IS_AVAILABLE_KEY);
    }
    extensionCallbacks.onAvailabilityChange(message.data);
  }
  if (message.type === MessagingType.ON_AMEYO_LOGGEDIN) {
    if (message.data) {
      localStorage.setItem(IS_AVAILABLE_KEY, 'true');
    } else {
      localStorage.removeItem(IS_AVAILABLE_KEY);
    }
    extensionCallbacks.onAvailabilityChange(message.data);
  }
  if (message.type === MessagingType.CAMPAIGN_ID) {
    extensionCallbacks.campaignId(message.data);
  }
  if (message.type === MessagingType.MULTIPLE_CAMPAIGNS_NEXT_BUTTON_CLICKED) {
    extensionCallbacks.multipleCampaignsNextButtonClicked();
  }
  if (message.type === MessagingType.TOGGLE_AMEYO_STATUS) {
    extensionCallbacks.toggleAmeyoStatus(message.data);
  }
  if (message.type === MessagingType.AMEYO_ERRONEOUS) {
    extensionCallbacks.ameyoErroneous();
  }
  if (message.type === MessagingType.AMEYO_GENERIC_CLICKSTREAM) {
    extensionCallbacks.ameyoGenericClickstream(message.data);
  }
  if (message.type === MessagingType.AMEYO_BACKGROUND_TAB_OPENED) {
    extensionCallbacks.ameyoBackgroundTabOpened(message.data);
  }
  if (message.type === MessagingType.AMEYO_BACKGROUND_TAB_OPEN_FAILED) {
    extensionCallbacks.ameyoBackgroundTabOpenFailed(message.data);
  }
  if (message.type === MessagingType.AMEYO_TAB_OPENING_ATTEMPT) {
    extensionCallbacks.ameyoTabOpeningAttempt(message.data);
  }
  if (message.type === MessagingType.MANUAL_LOGIN) {
    extensionCallbacks.manualLogin(message.data);
  }
  if (message.type === MessagingType.POPUP_TOGGLE_MID_CALL_CLICK) {
    extensionCallbacks.onExtensionToggleMidCallClick();
  }
  if (message.type === MessagingType.AMEYO_RELOADED) {
    extensionCallbacks.ameyoReloaded();
  }
  if (message.type === MessagingType.PING_PONG_CLICKSTREAM) {
    extensionCallbacks.pingPongClickstream(message.data);
  }
  if (message.type === MessagingType.ACCEPT_CALL_ERROR) {
    console.log('message type in accept call error', message.type);
    extensionCallbacks.acceptCallError();
  }
  if (message.type === MessagingType.SEND_CURRENT_CALL_STATUS) {
    const currentExtensionStatus = message.data;

    if (
      currentExtensionStatus.callStatus === AMEYO_CALL_EVENTS.DISCONNECTED ||
      currentExtensionStatus.callStatus === AMEYO_CALL_EVENTS.IDLE
    ) {
      extensionCallbacks.sendCurrentCallStatus();
      resetCallStatus();
      return;
    }

    if (currentExtensionStatus.callStatus === AMEYO_CALL_EVENTS.RINGING) {
      setCurrentCallStatus({
        ringingAt: Date.now(),
        acceptedAt: undefined,
        disconnectedAt: undefined,
        mutedAt: undefined,
        unMutedAt: undefined,
        phoneNumber: currentExtensionStatus?.phoneNumber,
        lan: currentExtensionStatus?.lan,
        crtObjectId: currentExtensionStatus?.crtObjectId
      });
    } else if (currentExtensionStatus.callStatus === AMEYO_CALL_EVENTS.CONNECTED) {
      setCurrentCallStatus({
        ringingAt: Date.now(),
        acceptedAt: Date.now(),
        disconnectedAt: undefined,
        phoneNumber: currentExtensionStatus?.phoneNumber,
        lan: currentExtensionStatus?.lan,
        crtObjectId: currentExtensionStatus?.crtObjectId
      });
    } else if (currentExtensionStatus.callStatus === AMEYO_CALL_EVENTS.DISCONNECTED) {
      setCurrentCallStatus({
        acceptedAt: Date.now(),
        ringingAt: Date.now(),
        disconnectedAt: Date.now()
      });
    }
  }
  if (message.type === MessagingType.SEND_CURRENT_CALL_STATUS_AND_RECALIBRATE) {
    extensionCallbacks.sendCurrentCallStatusAndRecalibrate(message?.data);
  }
  if (message.type === MessagingType.ACCEPT_CALL_CLICK_FAILURE) {
    extensionCallbacks.acceptCallClickFailure(message.type);
  }
  if (message.type === MessagingType.REJECT_CALL_CLICK_FAILURE) {
    extensionCallbacks.rejectCallClickFailure(message.type);
  }
  if (message.type === MessagingType.DISCONNECT_CALL_CLICK_FAILURE) {
    extensionCallbacks.disconnectCallClickFailure(message.type);
  }
  if (message.type === MessagingType.DISPOSE_CALL_CLICK_FAILURE) {
    extensionCallbacks.disposeCallClickFailure(message.type);
  }
}
export interface NaviExtensionCallbackRegister {
  onCallIncoming: (phoneNumber: string, lan: string, crtObjectId: string) => void;
  onCallConnected: (phoneNumber: string, lan: string, crtObjectId: string) => void;
  onCallRejected: (phoneNumber: string, lan: string, crtObjectId: string) => void;
  onCallDisconnected: (phoneNumber: string, lan: string, crtObjectId: string) => void;
  onAvailabilityChange: (isAvailable: boolean) => void;
  campaignId: (campaignId: string) => void;
  // onCallStatusChanged:()
}

export const AMEYO_STATUS_RANKS: Record<AMEYO_STATUS_CODES, { occuranceOrder: number }> = {
  [AMEYO_STATUS_CODES.LOADING]: { occuranceOrder: 1 },
  [AMEYO_STATUS_CODES.LOGGED_OUT]: { occuranceOrder: 2 },
  [AMEYO_STATUS_CODES.AUTH_ERROR]: { occuranceOrder: 3 },
  [AMEYO_STATUS_CODES.LOGGED_IN]: { occuranceOrder: 4 },
  [AMEYO_STATUS_CODES.DASHBOARD_LOADED]: { occuranceOrder: 5 },
  [AMEYO_STATUS_CODES.READY]: { occuranceOrder: 6 }
};

enum MessagingType {
  ON_LONGHORN_LOADED = 'onLonghornLoaded',
  GENRIC = 'generic',
  ON_AMEYO_LOGGEDIN = 'ameyoLoggedIn',
  ON_AMEYO_FORCE_LOGIN_POPUP = 'ameyoForceLoginPopup',
  ON_AMEYO_DASHBOARD_LOADED = 'ameyodashboardLoaded',
  GET_LH_AVAIALABILTY_STATE = 'getLhAvailabiltyState',
  ON_AMEYO_CALL_INCOMING = 'onAmeyoCallIncoming',
  ON_AMEYO_CALL_ACCEPTED = 'onAmeyoCallAccepted',
  ON_AMEYO_CALL_DISCONNECTED = 'onAmeyoCallDisconnected',
  SEND_MESSAGE_TO_LH_FROM_AMEYO = 'sendMessageToLhFromAmeyo',
  SEND_MESSAGE_TO_AMEYO_FROM_LH = 'sendMessageToAmeyoFromLh',
  ACCEPT_INCOMING_CALL = 'acceptIncomingCall',
  MUTE_ONGOING_CALL = 'muteOngoingCall',
  UNMUTE_ONGOING_CALL = 'unmuteOngoingCall',
  REJECT_INCOMING_CALL = 'rejectIncomingCall',
  DISCONNECT_CALL = 'disconnectIncomingCall',
  DO_LOGIN = 'doLogin',
  DO_LOGOUT = 'doLogout',
  SET_AMEYO_AVAILABILTY = 'setAmeyoAvailabilty',
  DISABLE_AMEYO = 'disableAmeyo',
  ENABLE_AMEYO = 'enableAmeyo',
  ON_ERROR = 'onError',
  ON_AMEYO_AVAILABILTY_CHANGE = 'onAmeyoAvailabiltyChange',
  ON_AMEYO_STATUS_CHANGE = 'onAmeyoStatusChange',
  DISPOSE_CALL = 'disposeCall',
  FOCUS_AMEYO_TAB = 'focusAmeyoTab',
  CAMPAIGN_ID = 'campaignId',
  MULTIPLE_CAMPAIGNS_NEXT_BUTTON_CLICKED = 'multipleCampaignsNextButtonClicked',
  TOGGLE_AMEYO_STATUS = 'toggleAmeyoStatus',
  AMEYO_ERRONEOUS = 'ameyoErroneous',
  AMEYO_GENERIC_CLICKSTREAM = 'ameyoGenericClickstream',
  AMEYO_TAB_OPENING_ATTEMPT = 'ameyoTabOpeningAttempt',
  AMEYO_BACKGROUND_TAB_OPENED = 'ameyoBackgroundTabOpened',
  AMEYO_BACKGROUND_TAB_OPEN_FAILED = 'ameyoBackgroundTabOpenFailed',
  MANUAL_LOGIN = 'manualLogin',
  POPUP_TOGGLE_MID_CALL_CLICK = 'extensionToggleMidCallClickEvent',
  AMEYO_RELOADED = 'ameyoReloaded',
  PING_PONG_CLICKSTREAM = 'pingPongClickstream',
  GET_CURRENT_CALL_STATUS = 'getCurrentCallStatus',
  SEND_CURRENT_CALL_STATUS = 'sendCurrentCallStatus',
  ACCEPT_CALL_ERROR = 'acceptCallError',
  SEND_CURRENT_CALL_STATUS_AND_RECALIBRATE = 'sendCurrentCallStatusAndRecalibrate',
  FOCUS_CHROME_EXTENSIONS_PAGE = 'focusChromeExtensionsPage',
  ACCEPT_CALL_CLICK_FAILURE = 'acceptCallClickFailure',
  REJECT_CALL_CLICK_FAILURE = 'rejectCallClickFailure',
  DISCONNECT_CALL_CLICK_FAILURE = 'disconnectCallClickFailure',
  DISPOSE_CALL_CLICK_FAILURE = 'disposeCallClickFailure',
  BLOCK_SLASH = 'blockSlash',
  UNBLOCK_SLASH = 'unblockSlash',
  DISABLE_EXTENSION_TOGGLE = 'DISABLE_EXTENSION_TOGGLE'
}

interface MessagingRequest {
  type: MessagingType;
  data: any | MessagingRequest;
}

export interface CurrentAmeyoCallStatus {
  ringingAt: number;
  acceptedAt: number;
  disconnectedAt: number;
  mutedAt: number;
  unMutedAt: number;
  phoneNumber: string;
  lan: string;
  crtObjectId: string;
}

export enum ErrorTypes {
  AUTH_ERROR = 'authError',
  GENERIC = 'generic',
  HIDDEN = 'hidden',
  MULTIPLE_CAMPAIGNS = 'multipleCampaigns',
  DOM_ELEMENT_NOT_FOUND = 'domElementNotFound'
}

export interface IAmeyoRecalibratedData {
  phoneNumber: string;
  crtObjectId: string;
  lan: string;
  callStatus: AMEYO_CALL_EVENTS;
  callId: string;
}
